import { useState } from "react";

import { useSessionRedirect } from "./useSessionRedirect";
import { useSignInAnonymously } from "./useSignInAnonymously";
import { useSubscribeOnAuthStateChanged } from "./useSubscribeOnAuthStateChanged";

export const useSignInFlow = () => {
  const [semaphore, setSemaphore] = useState<boolean>();

  useSubscribeOnAuthStateChanged(setSemaphore);
  useSignInAnonymously(semaphore);
  useSessionRedirect();
};
